import { createConfig, lazyRoute } from "../config/config-utils"

const SelectCorrectApp = lazyRoute(
  ()=> import("./SelectCorrectApp"),
  "SelectCorrectApp",
)

export const SELECT_CORRECT_CONFIG = createConfig({
  component: SelectCorrectApp,
  key: "select-correct",
  label: "Select Correct",
})
